// extracted by mini-css-extract-plugin
export default {"headerContainer":"_3Akpg","headerWrapper":"QMXxq","fullWidthHeader":"tcaDq","header":"_3Do4G","logo":"_3OAD4"};